import React, { useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import {
  CircularProgress,
  Backdrop,
  Button,
  ThemeProvider,
  createTheme,
} from "@mui/material";
import CommonHeader from "../components/CommonHeader";
import WebCameraInput from "../components/WebCameraInput";
import checkTodayKey from "../components/CheckTodayKey";
import axios from "axios";

const backBtnStyle = createTheme({
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          backgroundColor: "#c0c0c0",
          color: "#fff",
          fontSize: "1.0rem",
          "@media ( max-width: 752px )": {
            minWidth: "50vw",
          },
          "@media ( min-width: 753px )": {
            minWidth: "30vw",
          },
          "&:hover": {
            backgroundColor: "#a9a9a9",
          },
        },
      },
    },
  },
});

const ImageRegister = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState<boolean>(false);
  const captureedImageSrcRef = useRef<string | null>(null);
  const capturingPhotoRef = useRef<boolean>(true);

  const handleLoadingStart = () => {
    setLoading(true);
  };
  const handleLoadingClose = () => {
    setLoading(false);
  };
  // 顔認証撮影の画像をpropsで受け取ってfetchImagesを呼び出す
  const handleCaptureImage = (imageSrc: string, photoCapturing: boolean) => {
    captureedImageSrcRef.current = imageSrc;
    capturingPhotoRef.current = photoCapturing;
    fetchImages();
  };
  const handleJumpToHome = () => {
    captureedImageSrcRef.current = null;
    capturingPhotoRef.current = true;
    // ホーム画面に遷移
    navigate("/", {
      state: {
        isRegistered: true,
      },
    });
  };

  // Webからサーバーへの特徴点登録API
  // 成功/失敗はアラート表示
  const fetchImages = () => {
    handleLoadingStart();
    axios
      .post(
        "https://te81dmdu2h.execute-api.ap-northeast-1.amazonaws.com/Prod/facerecognizer",
        {
          process_flug: "register",
          image_s3_path: "",
          jtc_dt_val: "",
          is_photo_upload: "True",
          image_data: captureedImageSrcRef.current,
          boundingBoxInfo: "",
        },
      )
      .then((response) => {
        if (response.data.result) {
          alert("画像を登録しました");
        } else if (response.data.isMultiFace) {
          alert("複数の顔が検出されました\n一人ずつ撮影してください");
          capturingPhotoRef.current = true;
          captureedImageSrcRef.current = null;
        } else {
          alert("画像の登録に失敗しました\n再撮影してください");
          capturingPhotoRef.current = true;
          captureedImageSrcRef.current = null;
        }
      })
      .catch((error) => {
        console.error("Error fetching images:", error);
      })
      .finally(() => {
        handleLoadingClose();
      });
  };
  React.useEffect(() => {
    checkTodayKey(navigate);
  }, [navigate]);
  return (
    <div>
      <CommonHeader />
      {capturingPhotoRef.current ? (
        <>
          <p style={{ fontWeight: "bold", textAlign: "center", marginTop: "1rem"}}>
            顔情報を登録します
          </p>
          <WebCameraInput handleCaptureImage={handleCaptureImage} />
        </>
      ) : null}
      <div style={{ display: "flex", justifyContent: "center", marginTop: "1rem" }}>
        <ThemeProvider theme={backBtnStyle}>
          <Button onClick={handleJumpToHome}>ホームにもどる</Button>
        </ThemeProvider>
      </div>
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </div>
  );
};

export default ImageRegister;
